import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import SliderOne from "../../assets/img/main/sliderOne.png";
import SliderTwo from "../../assets/img/main/sliderTwo.png";
import SliderThree from "../../assets/img/main/sliderThree.png";
import SliderFour from "../../assets/img/main/sliderFour.png";
import "./Home.css";
import "animate.css";
import { FaFacebookF, FaWhatsapp } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { VscFeedback } from "react-icons/vsc";
import { Offcanvas } from "react-bootstrap";

function CarouselNew() {
  const [index, setIndex] = useState(0);
  const [showEnquiry, setShowEnquiry] = useState(false);
  const handleClose = () => setShowEnquiry(false);
  const handleShow = () => setShowEnquiry(true);

  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 1000) {
      setVisible(true);
    } else if (scrolled <= 1000) {
      setVisible(false);
    }
  };

  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };
  window.addEventListener("scroll", toggleVisible);
  return (
    <div className="position-relative overflow-hidden">
      <Carousel
        fade
        variant="light"
        activeIndex={index}
        onSelect={handleSelect}
        className="">
        <Carousel.Item className="vh-100" interval={6000}>
          <img
            className="d-block slider-img"
            src={SliderOne}
            alt="Global Trendz - Web | IT | Digital Marketing Services."
          />
          <Carousel.Caption className="">
            {/* <h1>
              Understanding & <strong>Strategizing</strong> our clients'
              business and <strong>Delivering</strong> a robust IT solution is
              what we do.
            </h1> */}
            <h1>Best Digital Marketing Company in India</h1>
            <p>
              We help businesses grow with expert SEO, social media marketing,
              Google Ads, and lead generation services. Enhance your online
              presence, attract more customers, and increase sales with proven
              marketing strategies.
            </p>
            <div className="myBtn banner-btn">
              <a href="/contact-us" className="global_btn">
                Get a Free Quote
              </a>
              <a href="tel:9840093858" className="global_btn">
                talk to experts
              </a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item className="vh-100" interval={6000}>
          <img
            className="d-block slider-img"
            src={SliderTwo}
            alt="Global Trendz - Web | IT | Digital Marketing Services."
          />
          <Carousel.Caption className="">
            {/* <h1>
              e-Commerce <strong>Consulting</strong> &{" "}
              <strong>Implementation</strong> is the key to making your venture
              work.

            </h1> */}
            <h1>Best Web Design and Development Company in India</h1>
            <p>
              We create responsive, user-friendly, and high-performing websites
              that enhance your brand and drive business growth. From custom
              website design to e-commerce development, we deliver solutions
              according to your needs.
            </p>
            <div className="myBtn banner-btn">
              <a href="/contact-us" className="global_btn">
                Get a Free Quote
              </a>
              <a href="tel:9840093858" className="global_btn">
                talk to experts
              </a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item className="vh-100" interval={6000}>
          <img
            className="d-block slider-img"
            src={SliderThree}
            alt="Global Trendz - Web | IT | Digital Marketing Services."
          />
          <Carousel.Caption className="">
            {/* <h1>
              Give your brand a <strong>Wider Reach</strong> of customers with
              the <strong>Influence</strong> of Digital Marketing.

            </h1> */}
            <h1>Best Ecommerce Consulting Services in India </h1>
            <p>
              We help businesses build effective ecommerce strategies through
              expert product and catalogue management, seamless payment and
              checkout solutions, enhanced customer experience and retention
              programs, and data-driven analytics and insights.
            </p>
            <div className="myBtn banner-btn">
              <a href="/contact-us" className="global_btn">
                Get a Free Quote
              </a>
              <a href="tel:9840093858" className="global_btn">
                talk to experts
              </a>
            </div>
          </Carousel.Caption>
        </Carousel.Item>
        {/* <Carousel.Item className="vh-100" interval={6000}>
          <img
            className="d-block slider-img"
            src={SliderFour}
            alt="Global Trendz - Web | IT | Digital Marketing Services."
          />
          <Carousel.Caption className="">
            <h1>
              We <strong>Assist</strong> our customers in establishing an{" "}
              <strong>Impactful</strong> web presence for their business.

            </h1>
          </Carousel.Caption>
        </Carousel.Item> */}
      </Carousel>
      <div className="right-bottom-curve"></div>
      <div className="right-top-curve"></div>

      <Offcanvas
        show={showEnquiry}
        onHide={handleClose}
        placement="end"
        id="enquiryForm">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          Some text as placeholder. In real life you can have the elements you
          have chosen. Like, text, images, lists, etc.
        </Offcanvas.Body>
      </Offcanvas>
      {/* <div className="whatsapp-icon">
        <a
          href="https://api.whatsapp.com/send?phone=917982828789"
          target="_balnk"
        >
          <img src={whatsappChat} alt="whatsapp-chat" />
        </a>
      </div> */}
    </div>
  );
}

export default CarouselNew;
